import React from 'react'
import { constants } from 'common/helpers'

import composeDialogModal from 'components/modal/DialogModal/composeDialogModal'

import messages from './messages'


const OutOfStockModal = composeDialogModal({
  name: constants.modals.limitedEditionProducts.OutOfStock,
  id: constants.modals.limitedEditionProducts.OutOfStock,
  title: ({ data: { cantMoveInQueue } }) => (
    cantMoveInQueue ? messages.cantMove.title : messages.title
  ),
  buttonTitle: messages.button,
  contentMessage: ({ data: { cantMoveInQueue } }) => (
    cantMoveInQueue ? messages.cantMove.text : messages.text
  ),
})

export default OutOfStockModal
